import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import Dialog from "@material-ui/core/Dialog";
import { Context } from "../../context/index";
import logo from "../../../content/assets/icons/logo.svg";
import signin from "../../../content/assets/icons/signin.svg";

const Header = styled.header`
  // position: sticky;
  // top: 0;
`;

const Flex = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 40px 0;
  a {
    text-transform: uppercase;
    font-size: 16px;
    font-family: DINProCond, Arial, Helvetica, Sans-Serif;
    font-weight: bold;
    margin: 0 5px;
    &:hover {
      color: #f05a28;
    }
  }
  p {
    text-transform: uppercase;
    font-size: 16px;
    font-family: DINProCond, Arial, Helvetica, Sans-Serif;
    font-weight: bold;
  }
`;

const Logo = styled.img`
  margin: auto 0;
  width: 120px;
  height: 72px;
  @media (max-width: 992px) {
    width: 50px;
    height: 30px;
  }
`;

const Nav = styled.nav`
  margin: 0 auto 0 100px;
  max-width: 600px;
  display: flex;
  justify-content: space-between;
  flex: 1;
  @media (max-width: 992px) {
    display: none;
  }
  .active {
    text-decoration: underline;
    text-underline-position: under;
  }
`;

const MobileMenu = styled.nav`
  padding: 25px;
  width: 100%;
  min-height: 320px;
  background: #f3f3f3;
  display: flex;
  flex-direction: column;
  a {
    text-transform: uppercase;
    font-size: 24px;
    font-family: DINProCond, Arial, Helvetica, Sans-Serif;
    font-weight: bold;
    margin: 5px;
    &:hover {
      color: #f05a28;
    }
  }
  p {
    text-transform: uppercase;
    font-size: 24px;
    font-family: DINProCond, Arial, Helvetica, Sans-Serif;
    font-weight: bold;
    margin: 5px;
  }
`;

const MobileIcon = styled.div`
  display: none;
  color: #f05a28;
  text-transform: uppercase;
  font-size: 16px;
  font-family: DINProCond, Arial, Helvetica, Sans-Serif;
  font-weight: bold;
  flex-direction: column;
  margin: 0;
  cursor: pointer;
  z-index: 2;
  text-decoration: underline #f05a28;
  text-underline-position: under;
  @media (max-width: 992px) {
    display: unset;
  }
`;

const Lang = styled.div`
  margin: 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  @media (max-width: 992px) {
    display: none;
  }
`;

const MobileLang = styled.div`
  margin: 5px 0;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  p {
    text-transform: uppercase;
    font-size: 24px;
    font-family: DINProCond, Arial, Helvetica, Sans-Serif;
    font-weight: bold;
    margin: 5px !important;
  }
  img {
    margin: 5px;
    width: 18px !important;
    height: 18px !important;
  }
`;

const SignButton = styled.div`
  width: 72px;
  margin: 0;
  @media (max-width: 992px) {
    margin: 4px 40px;
  }
  margin-left: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  cursor: pointer;
  img {
    width: 13px;
    height: 17px;
  }
  p {
    color: #f05a28;
    line-height: 19px;
    margin: 0;
    margin-left: 8px;
  }
`;
function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}

export default () => {
  const [isOpen, setOpen] = React.useState(false);
  // const {state: {user}} = React.useContext(Context)
  // console.log(user)
  const token =
    typeof window !== "undefined" ? window.localStorage.getItem("token") : null;
  const user = (token && parseJwt(token)) || null;
  return (
    <Header>
      <div className="container">
        <Flex>
          <a href="/">
            <Logo src={logo} alt="Monster visa logo" />
          </a>
          <Nav>
            <Link to="/sport" activeClassName="active">
              Спортивная страховка
            </Link>
            <Link to="/telemedicine" activeClassName="active">
              Телемедицина
            </Link>
            <Link to="/questions" activeClassName="active">
              Частые вопросы
            </Link>
            <Link to="/sports" activeClassName="active">
              Виды спорта
            </Link>

            <Link to="/blog" activeClassName="active">
              Блог
            </Link>
          </Nav>
          <Lang>
            {/* <Link to="/information" activeClassName="active">ru</Link>
            <Link to="/questions" activeClassName="active">en</Link> */}
            {user ? (
              <Link to="/account">
                <SignButton>
                  <img src={signin} alt="signin-icon" />
                  <p>{user.email}</p>
                </SignButton>
              </Link>
            ) : (
              <Link to="/sign-in">
                <SignButton>
                  <img src={signin} alt="signin-icon" />
                  <p>Войти</p>
                </SignButton>
              </Link>
            )}
          </Lang>
          <MobileIcon isOpen={isOpen} onClick={() => setOpen(!isOpen)}>
            Меню
          </MobileIcon>
          <Dialog
            open={isOpen}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth="xs"
          >
            <MobileMenu>
              <Link to="/sport" activeClassName="active">
                Спортивная страховка
              </Link>
              <Link to="/about" activeClassName="active">
                О компании
              </Link>
              <Link to="/partners" activeClassName="active">
                Партнерам
              </Link>
              <Link to="/documents" activeClassName="active">
                Документы
              </Link>
              <Link to="/requisites" activeClassName="active">
                Реквизиты
              </Link>
              <Link to="/information" activeClassName="active">
                Оплата и доставка
              </Link>
              <Link to="/questions" activeClassName="active">
                Частые вопросы
              </Link>
              <Link to="/sports" activeClassName="active">
                Виды спорта
              </Link>
              <MobileLang>
                {/* <Link to="/information" activeClassName="active">ru</Link>
                <Link to="/questions" activeClassName="active">en</Link> */}
                <Link to="/sign-in">
                  {user ? (
                    <Link to="/account">
                      <SignButton>
                        <img src={signin} alt="signin-icon" />
                        <p>{user.email}</p>
                      </SignButton>
                    </Link>
                  ) : (
                    <Link to="/sign-in">
                      <SignButton>
                        <img src={signin} alt="signin-icon" />
                        <p>Войти</p>
                      </SignButton>
                    </Link>
                  )}
                </Link>
              </MobileLang>
            </MobileMenu>
          </Dialog>
        </Flex>
      </div>
    </Header>
  );
};
